import { render, staticRenderFns } from "./NewFactcheckSuggestion.vue?vue&type=template&id=2682cf0d&scoped=true"
import script from "./NewFactcheckSuggestion.vue?vue&type=script&lang=ts"
export * from "./NewFactcheckSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./NewFactcheckSuggestion.vue?vue&type=style&index=0&id=2682cf0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682cf0d",
  null
  
)

export default component.exports